import React from "react";
import { any, map, propEq } from "ramda";
import { connect } from "react-redux";
import {
  addFacetDialogSelectedTerm,
  removeFacetDialogSelectedTerm,
} from "browse-media/redux/browseMediaActions";
import { Checkbox } from "react-toolbox/lib/checkbox";
import styles from "browse-media/components/BrowseMediaFacetCheckboxes.css";

const isSelected = (term, selectedTerms) =>
  any(propEq("code", term.code), selectedTerms);

const BrowseMediaFacetCheckboxes = ({
  availableTerms,
  displayName,
  onChangeTerm,
  selectedTerms,
}) => (
  <ul className={styles.list}>
    {map(
      term => (
        <li key={term.code} className={styles.listItem}>
          <Checkbox
            theme={styles}
            checked={isSelected(term, selectedTerms)}
            label={`${term.label} (${term.count.toLocaleString()})`}
            onChange={selected => onChangeTerm(selected, term)}
          />
        </li>
      ),
      availableTerms,
    )}
  </ul>
);

const mapStateToProps = state => state.browseMedia.facetDialog;

const mapDispatchToProps = dispatch => ({
  onChangeTerm: (selected, term) =>
    selected
      ? dispatch(addFacetDialogSelectedTerm(term))
      : dispatch(removeFacetDialogSelectedTerm(term)),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  BrowseMediaFacetCheckboxes,
);
